export default "__VITE_ASSET__ba13c8bd__"